module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "x-SECTION-BREAK"
  }), _vm._v(" "), _c('p', {
    staticClass: "x1PART-NUM",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#toc_marker-4"
    }
  }, [_vm._v("Part 1")])]), _vm._v(" "), _c('p', {
    staticClass: "x1PART-TTL"
  }, [_vm._v("AUTUMN"), _c('br'), _vm._v("YEAR 3988 IN THE AGE OF THE REALMS ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53323f7d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Part-1.vue
// module id = 72
// module chunks = 0